import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import queryString from 'querystring';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminRefund(routeProps: RouteComponentProps) {
  const [possibleText, setPossibleText] = useState('');
  const [impossibleText, setImPossibleText] = useState('');
  const option = queryString.decode(routeProps.location.search.substring(1));
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (option.update !== undefined && option.update) {
      const refundItem: any = routeProps.location.state;
      setPossibleText(refundItem.content1);
      setImPossibleText(refundItem.content2);
    }
  }, []);

  useEffect(() => {
    getRefund().then(() => {});
  }, []);

  // 최근 저장한 값 불러오기
  const getRefund = async () => {
    await server
      .getRefund()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setPossibleText(payload.items[0].content1);
          setImPossibleText(payload.items[0].content2);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // AdminGroupOrder 리턴값
  return (
    <main className="shipping wrapper">
      <div className="title">
        <h1>반품환불정보 관리</h1>
        <div className="buttons">
          <button
            type="button"
            onClick={async () => {
              await server
                .updateRefund({
                  content1: possibleText,
                  content2: impossibleText,
                })
                .then((payload) => {
                  if (!payload) {
                    dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
                  } else if (payload.code === 260 || payload.code === 500) {
                    dispatch(toast.error({ message: '파라미터 오류' }));
                  } else {
                    dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
                  }
                  getRefund();
                })
                .catch((error) => {
                  dispatch(
                    toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                  );
                  console.log(error);
                });
            }}
          >
            저장
          </button>
        </div>
      </div>
      <div className="content">
        <h3>교환/반품/환불이 가능한 경우</h3>
        <textarea
          name=""
          id=""
          value={possibleText}
          onChange={(dom) => {
            setPossibleText(dom.target.value);
          }}
        />
      </div>
      <div className="content">
        <h3>교환/반품/환불이 불가능한 경우</h3>
        <textarea
          name=""
          id=""
          value={impossibleText}
          onChange={(dom) => {
            setImPossibleText(dom.target.value);
          }}
        />
      </div>
    </main>
  );
}
